export default __webpack_public_path__ + "assets/cascader.66d4d850.svg";